
// import shared_refill_stock_default from '../shared/DefaultRefillStock'
import Api from '@/api/index';

const RefillRefillStock = {
  namespaced: true,
  state: {
    value: 'my value',

    oneRefillStock: null,
    allRefillStocks: [],
    activeRefillStocks: [],

  },
  getters: {
    getStateValue: state => {
      return state.value;
    }
  },

  mutations: {
    setOneRefillStock(state, refill_stock){
      state.oneRefillStock = refill_stock // refill_stock.data
    },
    setAllRefillStocks(state, refill_stocks){
      state.allRefillStocks = refill_stocks // refill_stocks.data
    },
    setActiveRefillStocks(state, refill_stocks){
      state.activeRefillStocks = refill_stocks // refill_stocks.data
    },

    updateFromManualRefillStocks(state, refill_stocks){
      let new_refill_stocks = state.allRefillStocks.map(as=> {
        let consolidated = null
        if (refill_stocks.find(s=> Number(s.id) == Number(as.id))){
          consolidated = refill_stocks.find(s=> Number(s.id) == Number(as.id)).consolidated
        } 
        return {...as, consolidated: consolidated || as.consolidated}
      })

      state.allRefillStocks = [...new_refill_stocks]
    },

    removeOneRefillStockFromList(state, refill_stock){
      let idx = state.allRefillStocks.findIndex(rs=> Number(rs.id) == Number(refill_stock.id))
      state.allRefillStocks.splice(idx, 1)
    },

    clearAllRefillStocks(state){
      state.allRefillStocks = null
    },
    clearActiveRefillStocks(state){
      state.activeRefillStocks = null
    },
    clearOneRefillStock(state){
      state.oneRefillStock = null
    },
  },

  actions: {
    clearAllRefillStocks({commit}){
      commit('clearAllRefillStocks')
    },
    clearOneRefillStock({commit}){
      commit('clearOneRefillStock')
    },

    index(context, filter) {
      // nao mt usado
      Api.RefillStock.index(filter).then(response => response.data).then(refill_stocks => {
        context.commit('setAllRefillStocks', refill_stocks);
      }).catch(function(error) {
        console.log(error);
      });
    },
    indexByModel(context, {model = 'depots', id}) {
      // uso principal
      Api.RefillStock.indexByModel({model, id}).then(response => response.data).then(refill_stocks => {
        context.commit('setAllRefillStocks', refill_stocks);
        return true
      }).catch(function(error) {
        console.log(error);
      });
    },
    show(context, refill_stock_id) {
      return Api.RefillStock.show(refill_stock_id).then(response => response.data).then(refill_stock => {
        context.commit('setOneRefillStock', refill_stock);
        return refill_stock
      }).catch(function(error) {
        console.log(error);
      });
    },
    update(context, refill_stock) {
      let notification = {}
      return Api.RefillStock.update(refill_stock).then(response => response.data).then(refill_stock => {
        // context.commit('setOneRefillStock', refill_stock); // not often used
        context.commit('removeOneRefillStockFromList', refill_stock)
        context.commit('clearOneRefillStock')
        notification.type = 'success'
        notification.msg = 'Feito com sucesso'
        return true
      }).catch(function(error) {
        console.log(error);
        notification.type = 'error'
        notification.msg = `Erro: ${err}`
      }).finally(() => {
        context.dispatch('Notification/add', notification, {root: true})
      })
    },

  }

};

export default RefillRefillStock;